var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62695 4.25C9.21273 4.25 8.87695 4.58579 8.87695 5C8.87695 5.41421 9.21273 5.75 9.62695 5.75H12.7116C13.1258 5.75 13.4616 5.41421 13.4616 5C13.4616 4.58579 13.1258 4.25 12.7116 4.25H9.62695Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7962 4.25C15.382 4.25 15.0462 4.58579 15.0462 5C15.0462 5.41421 15.382 5.75 15.7962 5.75H17.3386C17.5694 5.75 17.6769 6.03613 17.5032 6.18814L16.5037 7.06271C16.1919 7.33548 16.1604 7.8093 16.4331 8.12103C16.7059 8.43275 17.1797 8.46434 17.4914 8.19158L18.4909 7.31701C19.707 6.25294 18.9544 4.25 17.3386 4.25H15.7962Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4924 9.94073C15.8041 9.66797 15.8357 9.19415 15.563 8.88242C15.2902 8.57069 14.8164 8.5391 14.5046 8.81187L12.5056 10.561C12.1939 10.8338 12.1623 11.3076 12.4351 11.6193C12.7078 11.931 13.1817 11.9626 13.4934 11.6899L15.4924 9.94073Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4944 13.439C11.8061 13.1662 11.8377 12.6924 11.5649 12.3807C11.2922 12.069 10.8183 12.0374 10.5066 12.3101L8.50759 14.0593C8.19586 14.332 8.16428 14.8059 8.43704 15.1176C8.7098 15.4293 9.18362 15.4609 9.49535 15.1881L11.4944 13.439Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49632 16.9373C7.80805 16.6645 7.83964 16.1907 7.56687 15.879C7.29411 15.5672 6.82029 15.5357 6.50856 15.8084L5.50905 16.683C4.29297 17.7471 5.04556 19.75 6.66144 19.75H8.14126C8.55547 19.75 8.89126 19.4142 8.89126 19C8.89126 18.5858 8.55547 18.25 8.14126 18.25H6.66144C6.43059 18.25 6.32309 17.9639 6.49681 17.8119L7.49632 16.9373Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1009 18.25C10.6867 18.25 10.3509 18.5858 10.3509 19C10.3509 19.4142 10.6867 19.75 11.1009 19.75H14.0605C14.4748 19.75 14.8105 19.4142 14.8105 19C14.8105 18.5858 14.4748 18.25 14.0605 18.25H11.1009Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.d6e411b8c1634b26d2f20d3573070e91.svg";
export { ForwardRef as ReactComponent };